// eslint-disable-next-line react-hooks/exhaustive-deps
import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Accordion, AccordionTab } from "primereact/accordion";
import produce from "immer";
import * as numeral from "numeral";
import {useNavigate} from "react-router-dom";
import SubFormaCostos from "../cotizaciones/Rutas/formaCostos";
import { useEmpresa } from "../../../layout/EmpresaProvider";
import FieldInputNumber from "../../../shared/controls/fieldInputNumber";
import FieldTextBox from "../../../shared/controls/fieldTextBox";
import constantes from "../../../catalogos/constantes";
import FieldCheckBox from "../../../shared/controls/fieldCheckBox";
import FieldTextArea from "../../../shared/controls/fieldTextArea";
import useApiBanxico from "../../../api/administracion/useApiBanxico";
import useApiCotizaciones from "../../../api/comercial/cotizaciones";

const ModalCostos = ({
    visible,
    hide,
    rutaInicial,
    convenio,
    unidadDeMedida,
    viaje,
    editable,
    modificarComentarios = false,
    puedeModificarCosto = false,
    id,
    onGuardar
}) => {
    const [rutaModal, setRutaModal] = useState(rutaInicial);
    const { disable: disableEmpresa, empresa } = useEmpresa();
    const apiBanxico = useApiBanxico();
     const apiCotizaciones = useApiCotizaciones();
    const history = useNavigate();
    useEffect(() => {
        if (visible) {
            setRutaModal(rutaInicial);
            disableEmpresa();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible]);
    function actualizarCosto(nuevoCosto, name) {
        const nuevaRuta = produce(rutaModal, draft => {
            draft[name] = nuevoCosto;
            draft.unidadDeMedida = unidadDeMedida;
        });

        setRutaModal(nuevaRuta);
    }

    async function actualizar(value, name) {
        let nuevaRuta = produce(rutaModal, draft => {
            draft[name] = value;
            draft.unidadDeMedida = unidadDeMedida;
        });

            if (
                nuevaRuta.facturacionUsd &&
                (name === "facturacionUsd" || name === "tipoDeCambio")
            ) {
            let tipo = await apiBanxico.tipocambio();

            if (name === "tipoDeCambio") {
                tipo = value;
            }

            nuevaRuta = produce(nuevaRuta, draft => {
                draft.tipoDeCambio = tipo;
                draft.cambiarMontoFacturacionUsd();
            });
        } else if (nuevaRuta.facturacionUsd && name === "montoFacturacionUsd") {
            nuevaRuta = produce(nuevaRuta, draft => {
                draft.cambiarMontoFacturacionMxn();
            });
        }
    console.log("actualizar =>", { name, value });
        setRutaModal(nuevaRuta);
    }
    async function actualizarCostos(rutaModal) {
            console.log(convenio)
    await apiCotizaciones.actualizarCostos(convenio.convenio, rutaModal);
        history("/comercial");
    }
    const renderFooterModal = () => (
        <div>
            <Button
                label="Cerrar"
                onClick={hide}
                className="p-button-outlined"
                type="button"
            />
            <Button
                label="Guardar"
                onClick={() => actualizarCostos(rutaModal)}
                type="button"
            />
        </div>
    );

    if (!rutaModal || !rutaModal.costo || !unidadDeMedida) return null;

    return (
        <Dialog
            visible={visible}
            onHide={hide}
            style={{ width: "75vw" }}
            footer={renderFooterModal}
            header="Calcular costos"
        >
            <Accordion>
                <AccordionTab header="Cotización">
                    <SubFormaCostos
                        name="costo"
                        costo={rutaModal.costo}
                        onChange={actualizarCosto}
                        errors={false}
                        editable={editable}
                        unidadDeMedida={unidadDeMedida}
                        viaje={rutaModal.viaje || viaje}
                    />
                </AccordionTab>

                <AccordionTab
                    header={
                        <>
                            <span>Determinación de Precio</span>
                            <span className="accordion-description">
                                Facturación: {numeral(rutaModal.facturacionMxn).format("$0,0.00")}
                            </span>
                            <span className="accordion-description">
                                Utilidad: {numeral(rutaModal.utilidad).format("$0,0.00")}
                            </span>
                        </>
                    }
                >
                    <div className="form-row">
                        <FieldInputNumber
                            label="Accesorios"
                            colMd={2}
                            fractionDigits={2}
                            disabled
                            value={rutaModal.totalAccesorios}
                        />

                       <FieldInputNumber
                            name="facturacionMxn"
                            label={`Facturación ${empresa.moneda?.codigo ?? "MXN"}`}
                            colMd={3}
                            fractionDigits={2}
                            disabled={!editable}
                            value={rutaModal.facturacionMxn}
                            onChange={actualizar}
                        />

                        <FieldInputNumber
                            label="Utilidad"
                            colMd={2}
                            fractionDigits={2}
                            disabled
                            value={rutaModal.utilidad}
                        />

                        <FieldTextBox
                            label="Margen"
                            colMd={3}
                            disabled
                            value={rutaModal.margen}
                        />

                        <FieldInputNumber
                            label={`Precio por ${unidadDeMedida.abreviatura}`}
                            colMd={2}
                            fractionDigits={2}
                            disabled
                            value={rutaModal.precioPorKilometro}
                        />
                    </div>

                    <div className="form-row">
                        <FieldInputNumber
                            name="viajesPorSemana"
                            label="Viajes por Sem"
                            colMd={3}
                            fractionDigits={2}
                            disabled={!(editable || puedeModificarCosto)}
                            value={rutaModal.viajesPorSemana}
                            onChange={actualizar}
                        />

                        <FieldInputNumber
                            label="Utilidad por Sem."
                            colMd={3}
                            disabled
                            fractionDigits={2}
                            value={rutaModal.utilidadPorSemana}
                        />

                        <FieldInputNumber
                            name="viajesPorMes"
                            label="Viajes por Mes"
                            colMd={3}
                            disabled
                            fractionDigits={2}
                            value={rutaModal.viajesPorMes}
                        />

                        <FieldInputNumber
                            label="Utilidad por Mes"
                            colMd={3}
                            fractionDigits={2}
                            disabled
                            value={rutaModal.utilidadPorMes}
                        />

                        {empresa.moneda.id === constantes.monedas.pesos && (
                            <FieldCheckBox
                                name="facturacionUsd"
                                label="Facturacion USD"
                                disabled={!editable}
                                value={rutaModal.facturacionUsd}
                                onChange={actualizar}
                            />
                        )}
                    </div>

                    {rutaModal.facturacionUsd && (
                        <div className="form-row">
                            <FieldInputNumber
                                name="tipoDeCambio"
                                label="Tipo de cambio"
                                colMd={3}
                                fractionDigits={4}
                                disabled={!editable}
                                value={rutaModal.tipoDeCambio}
                                onChange={actualizar}
                            />

                            <FieldInputNumber
                                name="montoFacturacionUsd"
                                label="Facturación USD"
                                colMd={3}
                                fractionDigits={2}
                                disabled={!editable}
                                value={rutaModal.montoFacturacionUsd}
                                onChange={actualizar}
                            />
                        </div>
                    )}

                    <FieldTextArea
                        label="Desglose de Precios (opcional)"
                        name="desglosePrecios"
                        rows={5}
                        disabled={!editable && !modificarComentarios}
                        value={rutaModal.desglosePrecios}
                        onChange={actualizar}
                    />
                </AccordionTab>

                <AccordionTab header="Comentarios">
                    <div className="form-row">
                        <FieldTextArea
                            name="comentario"
                            rows={5}
                            disabled={!editable && !modificarComentarios}
                            value={rutaModal.comentario}
                            onChange={actualizar}
                        />
                    </div>
                </AccordionTab>
            </Accordion>
        </Dialog>
    );
};

export default ModalCostos;